import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const TextLink = ({ to, children, testId, className = "" }) => (
  <Link to={to} data-testid={testId} className={`text-link group inline-flex items-center gap-3 ${className}`}>
    <span className="text-link-label">{children}</span>
    <ArrowRight size={14} strokeWidth={1.25} className="transition-transform duration-500 group-hover:translate-x-1" />
  </Link>
);
